import { AccordionField } from '@components/DrawerAccordion';
import { MenuItem, TextField } from '@mui/material';
import { ChangeEventHandler, useState } from 'react';
import type { AgeCriteria, RangeOption } from '@/types/filterEnumTypes';

export type { AgeCriteria, RangeOption };

const COMPARATOR_OPTIONS: RangeOption[] = [
  'Equal to',
  'Older than or equal to',
  'Younger than or equal to',
];

type Props = {
  onChange: (payload: AgeCriteria) => void;
  defaultValue: AgeCriteria;
};

const Age = ({ onChange, defaultValue }: Props) => {
  const [age, setAge] = useState<string | null>(
    defaultValue.value ? String(defaultValue.value) : null
  );
  const [range, setRange] = useState<RangeOption | null>(defaultValue.range);

  const handleComparatorChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = (
    evt
  ) => {
    const newComparator = evt.target.value;
    if (newComparator === '') {
      setRange(null);
      setAge(null);
    }
    setRange(newComparator as RangeOption);
  };

  const handleAgeChange: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement> = (evt) => {
    const newAge = evt.target.value;

    const newAgeAsInt = parseInt(newAge);
    setAge(
      Number.isNaN(newAgeAsInt)
        ? null
        : newAgeAsInt < 0
          ? (newAgeAsInt * -1).toString()
          : newAgeAsInt.toString()
    );
  };

  const handleBlur = () => {
    onChange({ range, value: parseInt(age ?? '') });
  };

  return (
    <>
      <AccordionField>
        <TextField
          select
          label="Age range"
          placeholder="Select age range"
          value={range ?? ''}
          onChange={handleComparatorChange}
          onBlur={handleBlur}
        >
          <MenuItem value={''}>&nbsp;</MenuItem>
          {COMPARATOR_OPTIONS.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </AccordionField>
      <AccordionField>
        <TextField
          value={age ?? ''}
          onChange={handleAgeChange}
          placeholder="Enter an age"
          label="Age"
          inputMode="numeric"
          type="text"
          disabled={!range}
          onBlur={handleBlur}
        />
      </AccordionField>
    </>
  );
};

export default Age;
